<div matDialogTitle>
    <div style="width: calc(100% - 30px);">
        <span>{{title}}</span>
    </div>
    <button type="button" tabindex="-1" style="position: relative;right: 0px;width: 30px;height: 30px;margin-left: 0px; min-width: unset;padding: 0px;line-height: normal;"
            class="easy-form-close-btn" mat-button  (click)="onClose()">
        <mat-icon style="color: #ddd; font-size: 20px;margin-top: 5px;">close</mat-icon>
    </button>
</div>
<div matDialogContent style="flex-grow: 1; ">
    <div class="row narrow-padding">
        <div class="col-sm-12">
        <div class="card" style="border:0px;margin-left: 2vh;margin-right: 1vh;">
            <div class="card-header">
            <form class="c-form-inline" style="display: flex;">
                <div style="flex-grow: 1;"></div>
                <app-vis-button (click)="this.importSystemCodeType = this.systemCodeType" [label]="'匯入'" [icon]="'checklist'"></app-vis-button>
                <app-vis-button (click)="onAddRow()" *ngIf="canEdit" [label]="'新增'" [icon]="'add_circle'"></app-vis-button>
            </form>
            </div>
            <div class="card-body no-padding">
            <app-system-code-list-grid-view *ngIf="configs" [clinicId]="currentClinicId"
                [systemCodeType]="systemCodeType" [systemTypeData]="systemTypeList"
                [importTargetSystemCode]="importSystemCodeType"
                (onImportFinish)="this.importSystemCodeType=''">
            </app-system-code-list-grid-view>
            </div>
        </div>

        </div>
    </div>
  </div>